window.$ = window.jQuery = require('jquery');

((
    ($) => {
        const body = $('body');

        body.on('click', '[data-close-popup]', function (e) {
            e.preventDefault();
            let _target = $(this).data('close-popup');
            let _callBack = function () {
            };
            if (typeof $(this).attr('data-delete-popup') !== 'undefined' && $(this).attr('data-delete-popup') === 'true') {
                _callBack = function () {
                    $(this).remove();
                };
            }
            $('#' + _target).fadeOut(_callBack);
            body.removeAttr('style');
            remove_hash_from_url();
        });

        function remove_hash_from_url() {
            var location = window.location;
            var uri = `${location.protocol}//${location.hostname}${location.pathname}${location.search}`;

            if (location.toString().indexOf("#") > 0) {
                window.history.replaceState({},
                    document.title, uri);
            }
        }

        function popUp(item) {
            const _item = $(item);
            _item.fadeIn();
            body.css('overflow', 'hidden');
        }

        function handleHash(item) {
            const _item = $(item);
            if (_item.length) {
                if (_item.hasClass('popup__1')) {
                    popUp(_item);
                } else if (_item.hasClass('tab-hash')) {
                    blockTabs(_item);
                } else {
                    console.log('hh')
                    $('html, body').animate({scrollTop: _item.offset().top - 200}, 'fast');
                }
            }
        }

        function blockTabs(tab) {
            const _tab = $(tab);
            const _tab_parent = _tab.closest('.tabs-w');
            _tab_parent.find('.tab.active').removeClass('active');
            _tab_parent.find('.tab-content.active').removeClass('active').stop().slideUp();
            const hash = '#' + _tab.attr('id');
            $('[href="' + hash + '"]').addClass('active');
            _tab.addClass('active').stop().slideDown();

            // $('html, body').animate({scrollTop: _tab_parent.offset().top - 200}, 'fast');
        }

        window.addEventListener('hashchange', function (event) {
            if (window.location.hash) {
                handleHash($(window.location.hash));
            }
        });

        window.addEventListener('load', function (event) {
            if (window.location.hash) {
                handleHash($(window.location.hash));
            }
        });

        $('.tabs-w').each(function (index, tabs) {
            const tab = $(tabs).find('.tab').first();
            tab.addClass('active');

            const hash = tab.attr('href');
            $(`${hash}`).addClass('active').stop().slideDown();
        })

        $(document).on('click', function (e) {
            if ($(e.target).hasClass('popup__1--main-body')) {
                let _target = $(e.target).find('.popup__1--close').data('close-popup');
                $('#' + _target).fadeOut();
                body.removeAttr('style');
                remove_hash_from_url();
            }
        });
    }
)
(jQuery));
